import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["timeFields"];

  toggleAllDay(event) {
    const allDay = event.target.checked;
    this.timeFieldsTarget.classList.toggle("hidden", allDay);
    if (allDay) {
      this.timeFieldsTarget
        .querySelectorAll("input[type=time]")
        .forEach((input) => (input.value = ""));
    }
  }
}
